































































import Vue from 'vue';
import Vue2Filters from 'vue2-filters';
import { ReportSpec } from '@/components/ReportControls.vue';
import axios from 'axios';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAutorenew } from '@mdi/js';
import { DateTime } from "luxon";

Vue.use(Vue2Filters);


export default Vue.extend({
  name: 'OverviewTile',
  components: {
    SvgIcon,
  },
  props: {
    chartId: {
      type: String,
      default: 'overview-table',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    spec: Object as () => ReportSpec,
    data: Object as {},
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      if (this.spec?.dateStyle == "calendar") {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-overview/${depot}/${DateTime.fromJSDate(from).toISODate()}/${DateTime.fromJSDate(to).toISODate()}/`;
      } else {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-overview/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
      }
    },
  },
  data() {
    return {
      path: mdiAutorenew,
      size: 48,
      loading: true,
      currentData: {},
      previousData: {},
    };
  },
  watch: {
    spec: {
      immediate: true,
      async handler() {
        const response = await
            axios.get<{ current: { string: number }, previous: { string: number } }>(this.dataUrl, {
          params: {
            account_codes: this.spec.accountCodes.flatMap((a) => a.codes),

          },
        });
        this.currentData = response.data.current;
        this.previousData = response.data.previous;
        this.loading = false;
      },
    },
  },
});
